import _ from "lodash";
import { WEB_PORTAL_URL } from "@constant";
import {
  DATE_TIME_FORMAT,
  convertDateIntoUTCForTimezone,
  convertUTCDateIntoLocalDate,
} from "@datehandle";

export const validateEmail = (email) => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export function validatePhoneNumbers(value) {
  let re = /^\+\d{1,4} \d{6,14}$/;

  return re.test(value);
}

export const validateUrl = (url) => {
  let re =
    /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;

  // "http://example.com",
  // "https://www.example.com",
  // "http://subdomain.example.com",
  // "https://subdomain.example.com",
  // "http://www.subdomain.example.com",
  // "https://www.subdomain.example.com",
  // "http://example.com/path/to/resource",
  // "https://www.example.com/path/to/resource",
  // "http://subdomain.example.com/path/to/resource",
  // "https://subdomain.example.com/path/to/resource",
  // "http://www.subdomain.example.com/path/to/resource",
  // "https://www.subdomain.example.com/path/to/resource",
  // "http://example-domain.com",
  // "http://subdomain.example-domain.com",
  // "http://www.subdomain.example-domain.com",
  // "www.uco.co.in",
  // "http://www.uco.co.in",
  // "https://www.uco.co.in",
  // "https://app.eventify.io/assets/exhibitor_logo.jpg",
  // "http://app.eventify.io/assets/exhibitor_logo.jpg",
  // "www.app.eventify.io/assets/exhibitor_logo.jpg";

  return re.test(url);
};

export const validateOnlyNums = (value) => {
  // return value.replace(/[^\d]/g, "");
  // let check = !isNaN(value);
  var re = /^\d+$/;
  var check = re.test(value);

  return check;
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function checkDateFormatYMD(date) {
  // console.log("date :- ", date);
  var regex = new RegExp(/[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/);

  return regex.test(date);
}

export function priceDisplayLocally(price) {
  let options = {
    style: "decimal", // Other options: 'currency', 'percent', etc.
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  let pr = price.toLocaleString(
    navigator.language || navigator.userLanguage,
    options
  );
  return pr;
}

export function getValidFileName(filename) {
  let split = filename.split(".");
  let ext = split.pop();
  let newFname = split.join();

  // Remove special symbols and extra spaces and replace with '_'
  // newFname = "a@A9 8_)  *AÀA(Ań.";
  let newFnm = newFname.replace(/[^A-Z0-9]/gi, "_");
  let fileName = newFnm + "." + ext;

  return fileName;
}

export function generateFileName(filename) {
  let dynamic = Date.now();
  let split = filename.split(".");
  let ext = split.pop();
  let newFname = split.join();

  let fileName = newFname + "_" + dynamic + "." + ext;

  return fileName;
}

export function getFileDataArray(files) {
  let filesArray = [];
  files.forEach((file) => {
    let f1 = file.split("/").pop();
    let ext = f1.split(".").pop();
    let f2 = f1.substr(0, f1.lastIndexOf("_"));
    let fileName = f2 + "." + ext;

    filesArray.push({ file: file, filename: fileName });
  });

  return filesArray;
}

export const numberConversion = (value) => {
  if (typeof value === "string") return _.toNumber(value);
  else return value;
};

export const formUpFullName = (fName, lName) => {
  const bothPresent = !_.isEmpty(fName) && !_.isEmpty(lName);

  return `${fName}${bothPresent ? " " : ""}${lName}`;
};

export const isJSONParsable = (strVal) => {
  try {
    JSON.parse(strVal);
  } catch (e) {
    return false;
  }

  return true;
};

export function calculateAverageScore(scores) {
  // Normalize scores to a common denominator (out of 1)
  const normalizedScores = scores.map(([score, max]) => score / max);
  // Calculate the average of normalized scores
  const average = _.mean(normalizedScores);
  // Returning the average as a score out of 10
  return _.round(average * 10, 2);
}

export const webportalURL = (seocode) => {
  return _.includes(window.location.hostname, "eventify.io") ||
    _.includes(window.location.href, "localhost:3000")
    ? WEB_PORTAL_URL.replace(`{seocode}`, seocode)
    : `https://${seocode}`;
};

export const detectBrowser = () => {
  const nAgt = navigator.userAgent;

  const browsers = [
    { name: "Opera", pattern: /OPR\/([\d.]+)/ },
    { name: "Opera", pattern: /Opera\/([\d.]+)|Version\/([\d.]+)/ },
    { name: "Microsoft Internet Explorer", pattern: /MSIE ([\d.]+)/ },
    { name: "Chrome", pattern: /Chrome\/([\d.]+)/ },
    { name: "Safari", pattern: /Safari\/([\d.]+)|Version\/([\d.]+)/ },
    { name: "Firefox", pattern: /Firefox\/([\d.]+)/ },
  ];

  const formatBrowserInfo = (name, version) => ({
    platform: "web",
    devicename: name,
    model: name,
    systemversion: version,
    version,
    device: "",
    build: "",
    eventid: 0,
  });

  for (const { name, pattern } of browsers) {
    const match = nAgt.match(pattern);
    if (match) {
      return formatBrowserInfo(name, match[1] || match[2]);
    }
  }

  const fallbackMatch = nAgt.match(/(\w+)\/([\d.]+)$/);
  const fallbackName = fallbackMatch ? fallbackMatch[1] : navigator.appName;
  const fallbackVersion = fallbackMatch
    ? fallbackMatch[2]
    : navigator.appVersion;

  return formatBrowserInfo(fallbackName, fallbackVersion);
};

export const processHTMLContent = (htmlString, container = document.head) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // ✅ Append all style tags
  tempDiv.querySelectorAll("style").forEach((styleTag) => {
    const newStyle = document.createElement("style");
    newStyle.innerHTML = styleTag.innerHTML;
    container.appendChild(newStyle);
  });

  // ✅ Append all script tags
  tempDiv.querySelectorAll("script").forEach((scriptTag) => {
    const newScript = document.createElement("script");

    // Copy attributes (like src, async, type)
    [...scriptTag.attributes].forEach((attr) =>
      newScript.setAttribute(attr.name, attr.value)
    );

    // Inline JS
    if (scriptTag.innerHTML) {
      newScript.innerHTML = scriptTag.innerHTML;
    }

    container.appendChild(newScript);
  });

  // ✅ Append all noscript tags to body (if they exist)
  tempDiv.querySelectorAll("noscript").forEach((noscriptTag) => {
    container.insertAdjacentHTML("beforeend", noscriptTag.outerHTML);

    // ✅ Append all noscript tag's iframe (if they exist)
    const iframeHTML = noscriptTag.innerHTML.trim();
    const wrapper = document.createElement("div");
    wrapper.innerHTML = iframeHTML;

    const iframe = wrapper.querySelector("iframe");
    if (iframe) {
      iframe.classList.add("gtm-fallback-iframe");
      container.appendChild(iframe);
    }
  });

  //   let local_trackingpixel = JSON.parse(htmlString);
  //   let trackingpixel_header = local_trackingpixel?.header ?? "";
  //   let trackingpixel_footer = local_trackingpixel?.footer ?? "";

  //   if (trackingpixel_header !== "") {
  //     let head = document.querySelector("head");
  //     let innerScript = document
  //       .createRange()
  //       .createContextualFragment(trackingpixel_header);
  //     head.appendChild(innerScript);
  //   }
  //   if (trackingpixel_footer !== "") {
  //     let body = document.querySelector("body");
  //     let innerScript = document
  //       .createRange()
  //       .createContextualFragment(trackingpixel_footer);
  //     body.appendChild(innerScript);
  //   }
};

export const getTaxDetails = (ticket, eventSettingsData, userCountry) => {
  const ticketPrice = parseFloat(ticket?.price) || 0;
  const ownTaxRate = parseFloat(ticket?.tax) || 0;
  const ownTaxName = ticket?.taxname || "";

  const fallbackGlobalTaxRate = parseFloat(eventSettingsData?.data?.tax) || 0;
  const fallbackGlobalTaxName = eventSettingsData?.data?.taxname || "";

  const globalTaxJSON = JSON.parse(eventSettingsData?.data?.taxjson || "[]");

  let taxName = "";
  let taxAmount = 0;
  let priceWithTax = ticketPrice;
  const taxDetails = [];
  let applicableTaxes = [];

  // 1. Ticket-level tax
  if (ownTaxName) {
    taxName = `${ownTaxName}: ${ownTaxRate}%`;
    taxAmount = (ticketPrice * ownTaxRate) / 100;
    priceWithTax = ticketPrice + taxAmount;

    taxDetails.push({
      taxName: ownTaxName,
      taxRate: ownTaxRate,
      taxAmount: Number(taxAmount.toFixed(2)),
    });
  } else {
    // 2. Check globalTaxJSON for userCountry
    if (Array.isArray(globalTaxJSON) && globalTaxJSON.length > 0) {
      applicableTaxes = globalTaxJSON.filter((tax) => {
        const countries = (tax.country || "")
          .split(",")
          .map((c) => c.trim().toLowerCase());
        return countries.includes(userCountry?.toLowerCase());
      });

      if (applicableTaxes?.length === 0) {
        applicableTaxes = globalTaxJSON.filter((tax) => {
          const countries = (tax.country || "")
            .split(",")
            .map((c) => c.trim().toLowerCase());
          return countries.includes("all");
        });
      }

      let runningTaxAmount = 0;
      let runningPrice = ticketPrice;

      for (const tax of applicableTaxes) {
        const currentRate = parseFloat(tax.taxrate) || 0;
        const currentName = tax.taxname || "";
        const isCompound = tax.compoundtax === 1;

        const base = isCompound ? runningPrice : ticketPrice;
        const currentTaxAmount = Number(
          ((base * currentRate) / 100).toFixed(2)
        );

        runningPrice += currentTaxAmount;
        runningTaxAmount += currentTaxAmount;

        taxDetails.push({
          taxName: currentName,
          taxRate: currentRate,
          taxAmount: currentTaxAmount,
          compound: isCompound,
        });
      }

      taxName = taxDetails.map((t) => `${t.taxName}: ${t.taxRate}%`).join(", ");
      taxAmount = runningTaxAmount;
      priceWithTax = runningPrice;
    }
    // 3. Fallback global tax
    if (fallbackGlobalTaxName && applicableTaxes?.length === 0) {
      taxName = `${fallbackGlobalTaxName}: ${fallbackGlobalTaxRate}%`;
      taxAmount = (ticketPrice * fallbackGlobalTaxRate) / 100;
      priceWithTax = ticketPrice + taxAmount;

      taxDetails.push({
        taxName: fallbackGlobalTaxName,
        taxRate: fallbackGlobalTaxRate,
        taxAmount: Number(taxAmount.toFixed(2)),
      });
    }
  }

  return {
    taxName,
    taxAmount: Number(taxAmount.toFixed(2)),
    priceWithTax: Number(priceWithTax.toFixed(2)),
    taxDetails,
  };
};

export function activeTicetTier(ticket, eventtimezone) {
  if (!ticket || !ticket.tierjson || typeof ticket.tierjson !== "string")
    return false;

  let tiers;
  try {
    tiers = JSON.parse(ticket.tierjson);
  } catch (e) {
    console.warn("Invalid tierjson for ticket", ticket.ticketid);
    return false;
  }

  if (!Array.isArray(tiers) || tiers.length <= 1) return false;

  const timezone = eventtimezone || "UTC";
  const nowUTC = convertDateIntoUTCForTimezone(new Date(), timezone).format(
    DATE_TIME_FORMAT
  );
  // console.log("now", nowUTC);

  let activeTier = null;
  let activeIndex = -1;

  for (const [index, tier] of tiers.entries()) {
    if (!tier.salestartdate || !tier.saleenddate) continue;

    const startUTC = convertDateIntoUTCForTimezone(
      tier.salestartdate,
      timezone
    ).format(DATE_TIME_FORMAT);
    // console.log("startUTC", startUTC, tier.salestartdate);

    const endUTC = convertDateIntoUTCForTimezone(
      tier.saleenddate,
      timezone
    ).format(DATE_TIME_FORMAT);
    // console.log("endtUTC", endUTC, tier.saleenddate);

    if (nowUTC >= startUTC && nowUTC <= endUTC) {
      activeTier = tier;
      activeIndex = index;
      break;
    }
  }

  // If no active tier, fallback to first tier
  if (
    activeTier === null &&
    tiers.length > 0 &&
    tiers[tiers.length - 1]?.price != null
  ) {
    activeTier = tiers[tiers.length - 1];
    activeIndex = tiers.length - 1;
  }
  return { activeIndex, activeTier };
}

// We call this method for 2 reasons
// 1. To validate email format and domain
// 2. To enforce email format and domain restrictions for pre-approved emails
export function validateEmailDomain(emaildomainlist, email, source = "") {
  if (
    !emaildomainlist ||
    typeof emaildomainlist !== "string" ||
    emaildomainlist.trim() === ""
  )
    return source === "preapproved" ? false : true; // If condition met, then for preapproved return false, else return true

  if (!email || !validateEmail(email)) return false; // Invalid email format

  const emailDomainListArray = emaildomainlist
    .split(",")
    .map((domain) => domain.trim().toLowerCase());

  email = email.trim().toLowerCase();
  const emailDomain = email?.split("@")?.[1]; // Extract domain from email
  for (const allowed of emailDomainListArray) {
    // Wildcard check: *.com → allow any domain ending with .com
    if (allowed.startsWith("*.")) {
      const suffix = allowed.slice(1); // remove the '*'
      if (emailDomain.endsWith(suffix)) return true;
    }
  }

  return (
    emailDomainListArray.includes(emailDomain) ||
    emailDomainListArray.includes(email)
  );
}

export const checkForSelfAssign = (tickets) => {
  let groupTicketsArr = _.filter(tickets, (o) => {
    return o?.noofchildtickets;
  });
  let totalGroupTickets = _.sumBy(groupTicketsArr, function (o) {
    return o?.quantity || 0;
  });
  let generalTicketsArr = _.filter(tickets, (o) => {
    return o?.type !== "addon";
  });
  let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
    return o?.quantity || 0;
  });
  let addonTicketsArr = _.filter(tickets, (o) => {
    return o?.type === "addon";
  });
  let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
    return o?.quantity || 0;
  });

  let selfAssign = false;
  if (
    totalGroupTickets === 0 &&
    totalGeneralTickets === 1 &&
    totalAddonTickets > 0
  ) {
    selfAssign = true;
  }

  return selfAssign;
};

export function sessionRSVPAllowed(ticket, eventtimezone) {
  const timezone = eventtimezone || "UTC";
  const nowUTC = convertDateIntoUTCForTimezone(new Date(), timezone).format(
    DATE_TIME_FORMAT
  );
  const ticketSessionSettings = JSON.parse(ticket?.sessionsettings ?? "{}");
  // console.log({ ticketSessionSettings });
  // console.log({ nowUTC, n: new Date() });

  let output = { allowrsvp: true, maxsessionrsvp: "" };
  if (
    ticketSessionSettings?.sessionrsvptime?.starttime &&
    ticketSessionSettings?.sessionrsvptime?.endtime
  ) {
    let starttime = ticketSessionSettings.sessionrsvptime.starttime; // Session RSVP start time
    let endtime = ticketSessionSettings.sessionrsvptime.endtime; // Session RSVP end time

    const startUTC = convertDateIntoUTCForTimezone(starttime, timezone).format(
      DATE_TIME_FORMAT
    );
    // console.log(
    //   "startUTC",
    //   startUTC,
    //   starttime,
    //   convertUTCDateIntoLocalDate(startUTC, "PPp")
    // );

    const endUTC = convertDateIntoUTCForTimezone(endtime, timezone).format(
      DATE_TIME_FORMAT
    );
    // console.log(
    //   "endtUTC",
    //   endUTC,
    //   endtime,
    //   convertUTCDateIntoLocalDate(endUTC, "PPp")
    // );

    if (nowUTC < startUTC || nowUTC > endUTC) {
      output.allowrsvp = false;
      output.allowstatus = nowUTC < startUTC ? "not_started" : "ended";
      output.starttime = convertUTCDateIntoLocalDate(startUTC, "PPp");
      output.endtime = convertUTCDateIntoLocalDate(endUTC, "PPp");
    }
  }
  if (ticketSessionSettings?.maxsessionrsvp) {
    let maxsessionrsvp = ticketSessionSettings.maxsessionrsvp;
    output.maxsessionrsvp = parseInt(maxsessionrsvp);
  }

  return output;
}
